















import Vue from "vue";
import Component from "vue-class-component";
import Sidebars from "./sidebar.vue";
import AreaNavigation from "./navigation.vue";
import AreaFooter from "./footer.vue";
import config from "@/services/api-config";

@Component({
  components: {
    sidebar: Sidebars,
    navigation: AreaNavigation,
    cfooter: AreaFooter
  }
})
export default class Layout extends Vue {
  private clientHeight: number = 0;
  private max = 1440;
  private today = new Date();
  private value = this.today.getHours() * 60 + this.today.getMinutes();
  private userRoles = JSON.parse(localStorage[config.userRole]);
  private isAdmin = true;

  active: boolean = true;
  mounted() {
    this.clientHeight = window.innerHeight - 120;
    setInterval(() => {
      this.updateTime();
      this.updateIcon();
    }, 60000);

    this.updateIcon();
    if (!(this.userRoles.includes("admin") || this.userRoles.includes("tech")))
    {
      this.isAdmin = false;
    }
  }

  updateIcon() {
    const icon = document.getElementById("time-icon");

    if (icon) {
      icon.style.marginLeft = (this.value / 14.4 - 2).toString() + "%";
      icon.setAttribute("src", this.getImgUrl());
    }
  }

  getImgUrl() {
    if (this.$store.state.icon !== ''){
      return this.$store.state.icon;
    }
    
    if (this.today.getHours() > 4 && this.today.getHours() <= 5) {
      return require("../assets/images/Dawn.png");
    } else if (this.today.getHours() > 5 && this.today.getHours() <= 18) {
      if (this.$store.state.cloudy < 60) {
        return require("../assets/images/sun.png");
      } else if (this.$store.state.cloudy >= 60 && this.$store.state.cloudy < 80){
        return require("../assets/images/SunCloud.png");
      } else if(this.$store.state.cloudy >= 80){
        return require("../assets/images/clouds.png");
      }
    } else if (this.today.getHours() > 18 && this.today.getHours() <= 19) {
      return require("../assets/images/Dusk.png");
    } else {
      return require("../assets/images/moon.png");
    }
  }

  updateTime() {
    this.today = new Date();
    this.value = this.today.getHours() * 60 + this.today.getMinutes();
  }

  activated() {
    this.clientHeight = window.innerHeight - 120;
  }
}
